import React from "react";
import PropTypes from "prop-types";
import AccessoriesItem from "./AccessoriesItem";
import FilterItems from "../filterItems/FilterItems";
import { AccessoriesStyle } from "./AccessoriesStyle";

const Accessories = (props) => {
  return (
    <>
      <div className="customFilter d-none d-lg-block">
        {props?.accessoriesList?.length > 0 ? <p className="filter-heading">Accessories</p> : ""}
        {props?.accessoriesList?.map((item, index) => (
          <AccessoriesItem key={`accessory_${item.id}_${index}`}
                           accessories={item}
                           filteredAccessories={(props.filteredAccessories) ? props.filteredAccessories : []}
                           accessoriesClickHandler={(flag) => props.handleAccessoriesSelect(flag, item)}
          />
        ))}
      </div>
      <FilterItems heading="Accessories"
                   handleClick={props.Accessories}
                   id={props?.displayAccessories == true && props?.filteredAccessories?.length ? `filtered_brands_${props?.filteredAccessories}` : null}
                   renderFun={props?.filteredAccessories?.map(brand => brand.label).join(", ")}
      />
      <style jsx>{AccessoriesStyle}</style>
    </>
  );
};

Accessories.propTypes = {
  promotions: PropTypes.array,
  promo: PropTypes.func,
  filteredPromotions: PropTypes.string,
  handlePromotionSelect: PropTypes.func,
  accessoriesList: PropTypes.array,
  filteredAccessories: PropTypes.array,
  handleAccessoriesSelect: PropTypes.func,
  Accessories: PropTypes.any,
  displayAccessories: PropTypes.bool,
};

export default Accessories;
